module.exports = __webpack_public_path__ + "img/layout-en.641509e1.jpg";